// src/utils/harvestPortionAdjuster.js
import { doc, updateDoc, increment } from 'firebase/firestore';
import { db } from '../firebaseConfig';

/**
 * When editing an order, compute the difference in usage per harvest
 * and apply a single increment(oldUsed − newUsed).
 */
export async function adjustPortionsForEdit(activeFarmId, oldProduce, newProduce) {
  if (!activeFarmId) {
    throw new Error('No active farm selected');
  }
  // 1) Tally up usage per harvest
  const tally = (produceArr) => {
    return produceArr.reduce((map, entry) => {
      const portions = Number(entry.portions) || 0;
      entry.items.forEach(({ harvestId, proportion }) => {
        if (!harvestId) return;
        const used = portions * (Number(proportion) || 0);
        map[harvestId] = (map[harvestId] || 0) + used;
      });
      return map;
    }, {});
  };

  const oldUsage = tally(oldProduce);
  const newUsage = tally(newProduce);

  // 2) Build a list of all involved harvest IDs
  const allIds = new Set([
    ...Object.keys(oldUsage),
    ...Object.keys(newUsage),
  ]);

  // 3) For each one, increment(old − new)
  const writes = [];
  allIds.forEach((harvestId) => {
    const delta = (oldUsage[harvestId] || 0) - (newUsage[harvestId] || 0);
    if (delta !== 0) {
      const ref = doc(db, 'farms', activeFarmId, 'harvests', harvestId);
      writes.push(updateDoc(ref, { portionsLeft: increment(delta) }));
    }
  });

  await Promise.all(writes);
}
